import { render, staticRenderFns } from "./UpCultureForm.vue?vue&type=template&id=4175f4f2"
import script from "./UpCultureForm.vue?vue&type=script&lang=js"
export * from "./UpCultureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports